export default defineNuxtPlugin({
    async setup(nuxtApp) {
        const { t } = nuxtApp.$i18n;
        const cookieConsent = useCookieConsentStore();
        const cartStore = useCartStore();

        console.log('Running COOKIES Plugin')
        //check if we defined an auth source
        const cart_auth_method = useCookie('volt_cart_auth_method')
        if (cart_auth_method.value) {
            cartStore.setAuthMethod(cart_auth_method.value);
        }

        //see if there is a cart session cookie and set the cart session state.
        //setting the state will also refresh the cookie.
        const cart_session_id = useCookie('volt_cart_session_id');
        if (cart_session_id.value) {
            cartStore.setSession(cart_session_id.value);

            //since we have a session_id we might also have an active cart on the server. Lets fetch it.
            for (let tries = 0; tries < 10; tries++) {
                try {
                    await cartStore.fetchCart();
                    //if we get here we have sucessfully gotten the cart
                    break;
                } catch (e) {
                    if (e.authmismatch) {
                        if (tries >= 9) {
                            cartStore.setAuthMethod('web');
                            cartStore.setLocks([]);
                            cartStore.setLoginError(t('login.errors.auth_method_mismatch'))
                        }
                    }
                }

                //wait for a second and try again
                await new Promise(resolve => setTimeout(resolve, 1000));
            }
        }

        onNuxtReady(async() => {
            // check if there is a login redirect path
            const cart_loginRedirect = useCookie('volt_login_redirect');
            // set login redirect path and reset cookie
            if (cart_loginRedirect.value) {
                cartStore.setLoginRedirect(cart_loginRedirect.value, true);
                await navigateTo(cartStore.loginRedirect);
            }

            //check cookie consent
            const consent_cookie = useCookie('volt_cookie_consent2');
            //Delay 500ms to avoid nuxt hydratation error
            setTimeout(() => {
                if (!!consent_cookie.value) {
                    cookieConsent.setCookies(JSON.parse(atob(consent_cookie.value)));
                    cookieConsent.giveConsent();
                } else {
                    cookieConsent.resetConsent()
                }
            }, 500);
        }
    )}
})